import {useEffect} from 'react';

import {PublicClientApplication} from '@azure/msal-browser';
import {MsalProvider} from '@azure/msal-react';
import {ThemeProvider} from '@mui/material';
import {RouterProvider} from 'react-router-dom';

import {msalConfig} from './authConfig';
import InstallPwaModal from './components/pwa/InstallPwaModal';
import SpinnerRse from './components/spinner-rse/SpinnerRse';
import VisualdentityTestPage from './pages/VisualdentityTestPage';
import BannerProvider from './providers/BannerProvider';
import BudgetProvider from './providers/BudgetProvider';
import ChatbotProvider from './providers/ChatbotProvider';
import ContactProvider from './providers/ContactProvider';
import EmmaiProvider from './providers/EmmaiProvider';
import LoadingProvider from './providers/LoadingProvider';
import MainSidebarProvider from './providers/MainSidebarProvider';
import PaymentProvider from './providers/PaymentProvider';
import ProfileProvider from './providers/ProfileProvider';
import ProjectsCustomMappingsProvider from './providers/ProjectsCustomMappingsProvider';
import ProjectsProvider from './providers/ProjectsProvider';
import PwaProvider from './providers/PwaProvider';
import ReportParametersProvider from './providers/ReportParametersProvider';
import ReportProvider from './providers/ReportProvider';
import ReportSummaryProvider from './providers/ReportSummaryProvider';
import ReportViewsProvider from './providers/ReportViewsProvider';
import SnackbarProvider from './providers/SnackbarProvider';
import SpreadsheetsProvider from './providers/SpreadsheetsProvider';
import TranscriptProvider from './providers/TranscriptProvider';
import UploadProvider from './providers/UploadProvider';
import UserProvider from './providers/UserProvider';
import UserSecretsProvider from './providers/UserSecretsProvider';
import WorkspacesProvider from './providers/WorkspacesProvider';
import Router from './Router';
// eslint-disable-next-line import/order
import theme from './styles/mui-theme';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './styles/index.css';
import './fonts/soehne-breit-kraftig.woff2';
import './fonts/sohne.woff2';
import './fonts/InstrumentSans-Regular.ttf';
import './fonts/InstrumentSans-SemiBold.ttf';
import './fonts/Fieldwork-geo-demibold.otf';
import './fonts/Fieldwork-geo-light.otf';

export const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  useEffect(() => {
    const backgroundColor = import.meta.env.VITE_BACKGROUND_COLOR;
    if (backgroundColor) {
      document.documentElement.style.backgroundColor = backgroundColor;
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <LoadingProvider>
          <SnackbarProvider>
            <UserProvider>
              <ReportProvider>
                <ReportViewsProvider>
                  <ReportSummaryProvider>
                    <PaymentProvider>
                      <WorkspacesProvider>
                        <ProjectsProvider>
                          <ProjectsCustomMappingsProvider>
                            <ProfileProvider>
                              <UploadProvider>
                                <BannerProvider>
                                  <PwaProvider>
                                    <ChatbotProvider>
                                      <TranscriptProvider>
                                        <ContactProvider>
                                          <SpreadsheetsProvider>
                                            <MainSidebarProvider>
                                              <BudgetProvider>
                                                <SpinnerRse />
                                                <InstallPwaModal />
                                                <UserSecretsProvider>
                                                  <EmmaiProvider>
                                                    <ReportParametersProvider>
                                                      {import.meta.env.VITE_VISUAL_IDENTITY_TEST_MODE_ENABLED ? <VisualdentityTestPage /> : <RouterProvider router={Router} />}
                                                    </ReportParametersProvider>
                                                  </EmmaiProvider>
                                                </UserSecretsProvider>
                                              </BudgetProvider>
                                            </MainSidebarProvider>
                                          </SpreadsheetsProvider>
                                        </ContactProvider>
                                      </TranscriptProvider>
                                    </ChatbotProvider>
                                  </PwaProvider>
                                </BannerProvider>
                              </UploadProvider>
                            </ProfileProvider>
                          </ProjectsCustomMappingsProvider>
                        </ProjectsProvider>
                      </WorkspacesProvider>
                    </PaymentProvider>
                  </ReportSummaryProvider>
                </ReportViewsProvider>
              </ReportProvider>
            </UserProvider>
          </SnackbarProvider>
        </LoadingProvider>
      </MsalProvider>
    </ThemeProvider>
  );
};

export default App;
